import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-handicap-buy-light",
  "use": "icon-handicap-buy-light-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"icon-handicap-buy-light\"><path fill=\"#20B26C\" d=\"M2 3h6v14H2z\" /><path fill=\"#121214\" d=\"M10 3h8v2h-8zm0 4h8v2h-8zm0 4h8v2h-8v-2Zm0 4h8v2h-8v-2Z\" opacity=\".8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol